import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
} from '@angular/router';
import {
    AppStateFacade,
    UserAuthState,
} from '@app-state';
import { AuthService } from '@services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class NoSessionGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _authService: AuthService,
        private _appState: AppStateFacade,
    ) { }

    canActivate() {
        if (
            this._appState.user.authState === UserAuthState.NotLoggedIn ||
            this._authService.pendingLogout$.value ||
            this._appState.authConfig.value.auth.isCustomSsoEnabled
        ) { return true; }

        this._router.navigate(['']);

        return false;
    }
}
